//----- AUTOGENERATED (changes will be overwritten) -------
import * as Data$dIdentity from "../Data.Identity/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Foreign$dGeneric from "../Foreign.Generic/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const Table = x => x;
const eqDineInLocation = {eq: x => y => x.number === y.number};
const newtypeDineInLocation = {Coercible0: () => {}};
const hasFieldDineInLocation = dictHasField => dictHasField;
const genericDineInLocation = {to: x => x, from: x => x};
const showDineInLocation = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor({
      genericShowArgs: v => [
        (() => {
          const v$1 = Data$dShow.cons(Data$dShow.intercalate(": ")(["number", Data$dShow.showIntImpl(v.number)]))([]);
          if (v$1.length === 0) { return "{}"; }
          return Data$dShow.intercalate(" ")(["{", Data$dShow.intercalate(", ")(v$1), "}"]);
        })()
      ]
    })({reflectSymbol: () => "Table"});
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDineInLocation = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble$dGeneric.genericUnsafeDecodeTagged(genericDineInLocation)(Unscramble$dGeneric.genericDecodeSumConstruct({reflectSymbol: () => "Table"})({
      unsafeDecodeSingleConstructorArgument: Unscramble.decodeRecord(Unscramble.decodeRecordCons({reflectSymbol: () => "number"})(Unscramble.decodeInt1)(Unscramble.decodeRecordNil).recordInfo(Type$dProxy.Proxy))
    }))(Unscramble$dGeneric.defaultOptions)
  }
))();
const encodingOpts = /* #__PURE__ */ (() => (
  {
    sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
    unwrapSingleConstructors: true,
    unwrapSingleArguments: true,
    unwrapSingleRecordArguments: true,
    fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
  }
))();
const encodeDineInLocation = /* #__PURE__ */ (() => (
  {
    encode: Foreign$dGeneric$dClass.genericEncodeConstructor({reflectSymbol: () => "Table"})((() => {
      const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)({reflectSymbol: () => "number"})({
        encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce
      });
      return {
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
          Data$dList$dTypes.Nil
        )
      };
    })()).encodeOpts({
      sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
      unwrapSingleConstructors: false,
      unwrapSingleArguments: true,
      unwrapSingleRecordArguments: true,
      fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
    })
  }
))();
const decodeDineInLocation = /* #__PURE__ */ (() => (
  {
    decode: Foreign$dGeneric.genericDecode(genericDineInLocation)(Foreign$dGeneric$dClass.genericDecodeConstructor({reflectSymbol: () => "Table"})(Foreign$dGeneric$dClass.genericDecodeArgsRecord(Foreign$dGeneric$dClass.decodeWithOptionsRecord()(Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)({
      reflectSymbol: () => "number"
    })({decodeWithOptions: v => Foreign.readInt(Data$dIdentity.monadIdentity)})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))({
      sumEncoding: Foreign$dGeneric$dClass.defaultOptions.sumEncoding,
      unwrapSingleConstructors: false,
      unwrapSingleArguments: true,
      unwrapSingleRecordArguments: true,
      fieldTransform: Foreign$dGeneric$dClass.defaultOptions.fieldTransform
    })
  }
))();
export {
  Table,
  decodeDineInLocation,
  encodeDineInLocation,
  encodingOpts,
  eqDineInLocation,
  genericDineInLocation,
  hasFieldDineInLocation,
  newtypeDineInLocation,
  showDineInLocation,
  unscrambleDecodeDineInLocation
};
